var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',{attrs:{"id":"add-class-page","title":_vm.addNew}},[_c('main-information',{ref:"formRef",on:{"on-submit":_vm.addNewGradeScale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }